const s = {
  name: "Browser",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6.3,5c0,0.7-0.6,1.2-1.2,1.2C4.3,6.3,3.8,5.7,3.8,5c0-0.7,0.6-1.2,1.2-1.2C5.7,3.8,6.3,4.3,6.3,5z"/>
		<path class="st0" d="M9,6.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2C8.3,3.8,7.8,4.3,7.8,5C7.8,5.7,8.3,6.3,9,6.3z"/>
		<path class="st0" d="M14.2,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C13.7,3.8,14.2,4.3,14.2,5z"/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h34c1.7,0,3,1.3,3,3v34c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3z M3,2C2.4,2,2,2.4,2,3v5
			h36V3c0-0.6-0.4-1-1-1H3z M2,37c0,0.6,0.4,1,1,1h34c0.6,0,1-0.4,1-1V10H2V37z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Browser
};
